export default class CheckAll {
    #parentCheckElement
    #childCheckElements

    constructor(element) {
        this.#parentCheckElement = element
        this.#childCheckElements = document.querySelectorAll(element.dataset.gpTarget)

        this.#bindEvents()
        this.#handleChildCheckChange()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new CheckAll(element))
    }

    #bindEvents() {
        this.#parentCheckElement.addEventListener('change', this.#handleParentCheckChange)
        this.#childCheckElements.forEach((childCheckElement) =>
            childCheckElement.addEventListener('change', this.#handleChildCheckChange)
        )
    }

    #handleParentCheckChange = () => {
        this.#childCheckElements.forEach(
            (childCheckElement) => (childCheckElement.checked = this.#parentCheckElement.checked)
        )
    }

    #handleChildCheckChange = () => {
        let oneChecked = false
        let oneUnchecked = false

        this.#childCheckElements.forEach(({ checked }) => {
            if (checked && !oneChecked) {
                oneChecked = true
            }
            if (!checked && !oneUnchecked) {
                oneUnchecked = true
            }
        })

        // Indeterminate is only when there are both checked and unchecked children
        this.#parentCheckElement.indeterminate = oneChecked && oneUnchecked
        // Checked is only when there are no unchecked children(this condition can be simplified?)
        this.#parentCheckElement.checked = oneChecked && !oneUnchecked
    }
}
